const EDIT_APPLICATION = "application::edit";
const EDIT_APPLICATION_SUCCESS = "application::edit::success";
const EDIT_APPLICATION_FAILURE = "application::edit::failure";
const UPLOAD_APPLICATION = "application::upload";
const UPLOAD_APPLICATION_SUCCESS = "application::upload::success";
const UPLOAD_APPLICATION_FAILURE = "application::upload::failure";
const LOAD_APPLICATIONS_BY_ACCOUNT_SUCCESS =
  "application::load-by-account::success";
const LOAD_APPLICATIONS_BY_ACCOUNT_FAILURE =
  "application::load-by-account::failure";
const LOAD_APPLICATIONS_SUCCESS = "application::load-all::success";
const LOAD_APPLICATIONS_FAILURE = "application::load-all::failure";

export {
  LOAD_APPLICATIONS_BY_ACCOUNT_SUCCESS,
  LOAD_APPLICATIONS_BY_ACCOUNT_FAILURE,
  LOAD_APPLICATIONS_SUCCESS,
  LOAD_APPLICATIONS_FAILURE,
  EDIT_APPLICATION,
  EDIT_APPLICATION_SUCCESS,
  EDIT_APPLICATION_FAILURE,
  UPLOAD_APPLICATION,
  UPLOAD_APPLICATION_SUCCESS,
  UPLOAD_APPLICATION_FAILURE,
};
